export default __webpack_public_path__ + "images/assets/5567c7eb4176080310f12bfb8e70c6e9.svg";